import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Data Fitur"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, " Data fitur yang dimiliki ")
  ])
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, "List Feature", -1)
const _hoisted_6 = { class: "row g-4" }
const _hoisted_7 = { class: "p-3 border rounded-2" }
const _hoisted_8 = { class: "form-check fv-row" }
const _hoisted_9 = ["checked", "indeterminate", "onChange"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "form-check mt-4" }
const _hoisted_12 = ["checked", "onChange"]
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Update ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" })
], -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

import { onBeforeMount, ref, reactive, onMounted } from "vue";
import Loading from "vue-loading-overlay";
import { SelectedFeature } from "../model/MasterPricing";
import ApiService from "@/core/services/ApiService";
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isLoading = ref(false);
const fullPage = ref(true);
const isColor = "#007BFF";
const isBackgroundColor = "#A3A3A3";
const isOpacity = 0.5;

const name = ref("");

const tableData = ref<SelectedFeature[]>([]);
const selectedFeatures = reactive<SelectedFeature[]>([]);

const toast = useToast();
const router = useRouter();
const route = useRoute();
const datas = ref({});

const getData = () => {
  let search = "";
  if (name.value) {
    search = "feature_name=" + name.value + "&";
  } else {
    search;
  }
  ApiService.getWithoutSlug(
    `/crmv2/main_feature/subscriptions/feature/${route.params._id}`
  )
    .then(({ data }) => {
      console.log(data);

      datas.value = data;
      tableData.value = data.features;
      tableData.value.map((s) =>
        selectedFeatures.push({
          ...s,
          feature_status: s.feature_status
            ? s.feature_status
            : s.detail_modules.some((d) => d.module_status === true)
            ? true
            : false,
        })
      );
      isLoading.value = false;
    })
    .catch((e) => {
      console.log(e);
      if (e.response.status == 401) {
        toast.error(e.response.data.detail);
        router.push("/sign-in");
        isLoading.value = false;
      } else {
        toast.error(e.response.data.detail);
        isLoading.value = false;
      }
    });
};

function getFeatureIndex(fid) {
  return selectedFeatures.findIndex((f) => f.feature_id === fid);
}

function isFeatureChecked(fid) {
  const index = getFeatureIndex(fid);
  if (index === -1) return false;
  return (
    selectedFeatures[index].feature_status === true &&
    selectedFeatures[index].detail_modules.every((m) => m.module_status)
  );
}

function isFeatureIndeterminate(fid) {
  const index = getFeatureIndex(fid);
  if (index === -1) return false;
  const modules = selectedFeatures[index].detail_modules;
  const checked = modules.filter((m) => m.module_status).length;
  if (selectedFeatures[index].feature_status && modules.length) return true;
  return checked > 0 && checked < modules.length;
}

function isModuleChecked(fid, mid) {
  const fIdx = getFeatureIndex(fid);
  if (fIdx === -1) return false;
  return selectedFeatures[fIdx].detail_modules.some(
    (m) => m.module_key === mid && m.module_status
  );
}

function onFeatureToggle(feature) {
  console.log(feature);

  const fIdx = getFeatureIndex(feature.feature_id);
  console.log(fIdx);

  const isSelected =
    fIdx !== -1 &&
    selectedFeatures[fIdx].feature_status &&
    selectedFeatures[fIdx].detail_modules.every(
      (mod) => mod.module_status === true
    );
  const isIndeterminate =
    fIdx !== -1 &&
    selectedFeatures[fIdx].feature_status &&
    selectedFeatures[fIdx].detail_modules.length > 0
      ? true
      : false;

  if (isSelected) {
    const a = selectedFeatures.splice(fIdx, 1);
    console.log(a);
  } else if (isIndeterminate) {
    selectedFeatures[fIdx].detail_modules = feature.detail_modules.map(
      (mod) => ({
        ...mod,
        module_status: true,
      })
    );
  } else {
    selectedFeatures.push({
      feature_id: feature.feature_id,
      name: feature.name,
      feature_status: true,
      detail_modules: feature.detail_modules.map((mod) => ({
        ...mod,
        module_status: true,
      })),
    });
  }
}

function onModuleToggle(feature, module) {
  const fIdx = getFeatureIndex(feature.feature_id);

  console.log("id", feature.feature_id);
  console.log("fidx", fIdx);

  if (fIdx === -1) {
    selectedFeatures.push({
      feature_id: feature.feature_id,
      feature_name: feature.feature_name,
      feature_status: false,
      detail_modules: feature.detail_modules.map((mod) => ({
        ...mod,
        module_status: mod.module_key === module.module_key,
      })),
    });
  } else {
    const featureData = selectedFeatures[fIdx];
    const moduleIdx = featureData.detail_modules.findIndex(
      (m) => m.module_key === module.module_key
    );

    // Toggle status module
    featureData.detail_modules[moduleIdx].module_status =
      !featureData.detail_modules[moduleIdx].module_status;

    // Update feature_status
    const allChecked = featureData.detail_modules.every((m) => m.module_status);
    const noneChecked = featureData.detail_modules.every(
      (m) => !m.module_status
    );

    featureData.feature_status = allChecked;

    if (noneChecked) {
      selectedFeatures.splice(fIdx, 1);
    }
  }
}

const handleSubmit = async () => {
  datas.value.features = selectedFeatures;
  try {
    isLoading.value = true;
    await ApiService.putWithData(
      `/crmv2/main_feature/subscriptions/feature/${route.params._id}`,
      datas.value
    );
    toast.success("Data berhasil di simpan");
  } catch (error) {
    toast.error("Somethin went wrong");
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Loading), {
      active: isLoading.value,
      "is-full-page": fullPage.value,
      color: isColor,
      "background-color": isBackgroundColor,
      opacity: isOpacity
    }, null, 8, ["active", "is-full-page"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (items, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: items.feature_id,
              class: "col-4"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    checked: isFeatureChecked(items.feature_id),
                    indeterminate: isFeatureIndeterminate(items.feature_id),
                    onChange: ($event: any) => (onFeatureToggle(items))
                  }, null, 40, _hoisted_9),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: `${items.name} ${index}`
                  }, _toDisplayString(items.name), 9, _hoisted_10)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.detail_modules, (detailModule, indexModule) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "ms-3 row-columns",
                    key: indexModule
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        checked: 
                        isModuleChecked(
                          items.feature_id,
                          detailModule.module_key
                        )
                      ,
                        onChange: ($event: any) => (onModuleToggle(items, detailModule))
                      }, null, 40, _hoisted_12),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: `${detailModule}-${indexModule}`
                      }, _toDisplayString(detailModule.module_key), 9, _hoisted_13)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "btn btn-danger me-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/superadmin/master-feature/school')))
        }, " Batal "),
        _createElementVNode("button", {
          type: "button",
          id: "kt_account_profile_details_submit",
          ref: (_value, _refs) => {
            _refs['submitButton'] = _value
          },
          class: "btn btn-primary",
          onClick: handleSubmit
        }, _hoisted_17, 512)
      ])
    ])
  ]))
}
}

})